export default function haveExistingRequest(context, { customerId, id }) {
  if (!context.stores.customers.has({ id: customerId })) {
    return false;
  }
  const { aiTextCompletions } = context.stores.customers.storesFor(customerId);
  return aiTextCompletions.isLoading({ id });
}
